import "./styles/styles.scss";
import { AppProvider } from "./router/AppProvider";
import PreRouter from "./PreRouter";
import { gtag, install } from "ga-gtag";
import { useEffect } from "react";

function App() {
  install("UA-119291951-1");

  useEffect(() => {
    const existingLanguage = localStorage.getItem("language");
    if (!existingLanguage) {
      localStorage.setItem("language", "es");
    }
  }, []);

  return (
    <AppProvider>
      <PreRouter />
    </AppProvider>
  );
}

export default App;

